var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-card',[_c('template',{slot:"header"},[_vm._v("\n    Cash-events\n  ")]),_c('simple-list',{attrs:{"object-name":"cashEvent","query-store-name":"cashEvent","columns":_vm.columns}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }